/**
 * @module mapbs.components.applications.applicationlink.applicationLink
 */

import './applicationlink.scss';

import angular from 'angular';

const alModule = angular.module('mapbsApplicationLinkModule', []);

alModule.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/applicationLink',
            require('./applicationlink.html')
        );
    }
);

/**
 * @type {!angular.Component}
 */
const ApplicationLinkComponent = {
    controller: 'mapbsApplicationLinkController as ctrl',
    templateUrl: 'mapbs/applicationLink',
    bindings: {
        'title': '<mapbsApplicationlinkTitle',
        'description': '<?mapbsApplicationlinkDescription',
        'url': '<mapbsApplicationlinkUrl',
        'active': '<mapbsApplicationlinkActive',
        'mobile': '<?mapbsApplicationlinkMobile',
    },
};

alModule.component('mapbsApplicationlink', ApplicationLinkComponent);

class ApplicationlinkController {
    /**
   * @param {import('ngeo/statemanager/Location')} ngeoLocation
   * @param {angular.auto.IInjectorService} $injector Main injector.
   * @param {angular.$http} $http the angular http service
   * @constructor
   * @private
   * @ngInject
   */
    constructor(ngeoLocation, $injector, $http) {
    /**
     * @type {import('ngeo/statemanager/Location')}
     * @private
     */
        this.ngeoLocation_ = ngeoLocation;

        /**
     * @type {string}
     */
        this.title;

        /**
     * @type {string}
     */
        this.description;

        /**
     * @type {string | ApplicationUrl}
     */
        this.url;

        /**
     * @type {boolean}
     */
        this.active = false;

        /**
     * @type {boolean}
     */
        this.mobile = false;

        /** @type {string} */
        this.baseURL = `${$injector.get('baseUrl')}`;

        this.http = $http;
    }

    getUrl() {
        if (typeof this.url === 'string') {
            return this.url;
        }

        const query = {
            'paramX': this.ngeoLocation_.getParam('map_x') || null,
            'paramY': this.ngeoLocation_.getParam('map_y') || null,
            'paramZoom': this.ngeoLocation_.getParam('map_zoom') || null,
        };

        const queryString = Object.keys(query).reduce((paramString, param) => {
            if (
                typeof query[param] !== 'undefined' &&
        query[param] &&
        typeof this.url[param] !== 'undefined'
            ) {
                return `${paramString ? `${paramString}&` : ''}${this.url[param]}=${
                    query[param]
                }`;
            } else {
                return paramString;
            }
        }, '');

        return `${this.url.origin}${
            this.url.origin.includes('?') ? '&' : '?'
        }${queryString}`;
    }

    logging(topic, action) {
        this.http.get(`${this.baseURL}logging?topic=${topic}&action=${action}`);
    }
}

alModule.controller('mapbsApplicationLinkController', ApplicationlinkController);

export default alModule;
